// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../index';

import { gql } from 'graphql-tag';
export const RingSizeFragmentDoc = gql`
    fragment ringSize on RingSize {
  __typename
  id
  ringSizeLabel: label(country: $country)
}
    `;